<!-- Адаптер редактирования точки заказа к единой модалке точки маршрута -->
<template>
  <RoutePointModal
    resource-type="order"
    :resource-id="orderId"
    :point-id="orderPointId"
    :company-id="companyId"
    :show-actual-datetime="false"
    @close="$emit('close')"
    @updated="$emit('points-updated')"
    @deleted="$emit('points-deleted')"
  />
</template>

<script>
import RoutePointModal from "@/components/RoutePoint/RoutePointModal.vue";

export default {
  name: "EditOrderPointsModal",

  components: {
    RoutePointModal,
  },

  emits: ["close", "points-updated", "points-deleted"],

  props: {
    orderId: {
      type: [String, Number],
      required: true,
    },
    orderPointId: {
      type: Number,
      required: true,
    },
    companyId: {
      type: Number,
      required: true,
    },
  },
};
</script>
